<template>
  <AppLayout>
    <div class="transaction">
      <section id="transaction-products">
        <div class="container">
  
          <h6  class="fw-bold" >Stock Adjustment Logs</h6>
  
          <div class="filter-search" style="margin-top: 0; padding-left: 0px">
            <div class="filter-search-header">
              <p>Filter</p>
              <p class="clear" @click="clear">Clear</p>
            </div>
            <div class="filter-search-body">
              <div class="form">
                <div class="row">
                  <div class="col-md-2 align-self-end">
                    <div class="form-group">
                      <label for="date">Date From</label>
                      <input type="date" class="form-control" v-model="dateFrom" @change="filterTable" />
                    </div>
                  </div>
                  <div class="col-md-2 align-self-end">
                    <div class="form-group">
                      <label for="date">Date To</label>
                      <input type="date" class="form-control" v-model="dateTo" @change="filterTable" />
                    </div>
                  </div>
                      <div class="col" style="margin-top:8px; display:flex; gap:8px; align-items:center; justify-content:flex-end;">
                        <button v-if="!uploading" class="btn text-primary btn-sm" @click="downloadTemplate">Download CSV Template</button>

                        <div v-if="!uploading" class="file-input-wrapper">
                          <label for="stockAdjustFile" class="btn btn-style-2 btn-sm file-label">Choose File</label>
                          <input id="stockAdjustFile" type="file" accept=".csv,.xlsx,.xls" @change="onFileChange" class="file-input" />
                          <span class="file-name text-muted" v-if="uploadFile">{{ uploadFile.name }}</span>
                        </div>

                        <button v-if="!uploading" class="btn btn-outline btn-sm" @click="uploadCsv" :disabled="!uploadFile || uploading || !csvValid">Upload CSV</button>
                        <div v-if="uploading" style="margin-left:8px; display:flex; align-items:center; gap:8px;">
                          <div class="spinner-border spinner-border-sm" role="status">
                            <span class="visually-hidden">Uploading...</span>
                          </div>
                          <small class="text-primary">Uploading...</small>
                        </div>
                      </div>
                        <div v-if="uploadFile" style="margin-top:8px">
                        <div v-if="!csvValid" class="text-danger">Invalid CSV headers. Required: Product Name, New Quantity</div>
                        <div v-else class="text-primary"><strong>First: {{ previewRows.length }} rows</strong> <span class="text-warning">Make sure you are uploading the correct file</span></div>
                        <table v-if="previewRows.length > 0" class="table table-sm" style="width:100%; margin-top:8px">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th v-for="h in previewHeaders" :key="h">{{ h }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(r, i) in previewRows" :key="i">
                              <td>{{ i+1 }}</td>
                              <td v-for="c in previewHeaders" :key="c">{{ r[c] }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      
                      

                </div>
              </div>
            </div>
          </div>
  
          <div class="products-list transaction-products-list" style="margin-top: 0px;">
            <!--<strong style="margin-top: 0px">Stock Adjustment Log List</strong>
             <keep-alive> -->
            <SkeletonLoader v-if="loading" type="table" :rows="6" :columns="13" />

            <table class="table table-hover" id="adjustmentsTable" v-show="!loading">
              <thead>
                <th>No.</th>
                <th>Date</th>
                <th>Activity</th>
                <th>Product Name</th>
                <th>Warehouse</th>
                <th>Qty Before</th>
                <th>Qty Adjusted</th>
                <th>New Qty Avail</th>
                <th>Reason</th>
                <th>Requester</th>
                <th>Actioned By</th>
                <th>Actioned Date</th>
                <th>Status</th>
              </thead>
            </table>

            <div v-if="uploadResults.length || uploadErrors.length" style="margin-top:13px">
              <h6>Upload Results</h6>
              <div v-if="uploadResults.length">
                <strong>Processed</strong>
                <table class="table table-sm">
                  <thead><tr><th>#</th><th>Row</th><th>Product</th><th>Status</th><th>Adjustment ID</th></tr></thead>
                  <tbody>
                    <tr v-for="(r, i) in uploadResults" :key="i">
                      <td>{{ i+1 }}</td>
                      <td>{{ r.row }}</td>
                      <td>{{ r.product }}</td>
                      <td>{{ r.status }}</td>
                      <td>{{ r.adjustmentId || '-' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="uploadErrors.length">
                <strong>Errors</strong>
                <table class="table table-sm table-danger">
                  <thead><tr><th>#</th><th>Row</th><th>Product</th><th>Message</th></tr></thead>
                  <tbody>
                    <tr v-for="(e, i) in uploadErrors" :key="i">
                      <td>{{ i+1 }}</td>
                      <td>{{ e.row }}</td>
                      <td>{{ e.product || '-' }}</td>
                      <td>{{ e.message }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- fallback when no records -->
            <div v-if="!loading && activities.length < 1">
              <label for="" class="alert alert-danger" style="margin: 0px auto; width: fit-content; display: block;">No log found</label>
            </div>
          <!-- </keep-alive> 
            <div v-if="activities.length < 1">
              <label for="" class="alert alert-danger" style="margin: 0px auto; width: fit-content; display: block;">No log found</label>
            </div>
            -->

          </div>
        </div>
      </section>
    </div>
  </AppLayout>
  </template>
  
  <script>
  
  import Swal from 'sweetalert2'
  import SkeletonLoader from '../../components/SkeletonLoader.vue'
  import AppLayout from '../../components/AppLayout.vue';
  import 'datatables.net-vue3';
  import 'datatables.net-bs5';
  import "datatables.net-buttons-bs5";
  import "datatables.net-responsive-bs5";
  import $ from 'jquery';
  import 'jszip';
  import 'datatables.net-buttons/js/buttons.html5.js';
  import 'datatables.net-buttons/js/buttons.html5.js';
  import 'datatables.net-buttons/js/buttons.colVis.js';
  import 'datatables.net-buttons/js/buttons.print.js';
  import { docFooter } from '@/utils/common';

  export default {
    name: 'StockAdjsutments',
    components: {
      AppLayout,
      SkeletonLoader
    },
     
     
    data: () => ({
        token: JSON.parse(localStorage.getItem('access_token')),
        dateFrom: "",
        dateTo: "",
        activities: [],
        dataTable:  null,
        processedData: [],
        loading: false,
        activitiesDatas: [],
        uploadFile: null,
        uploadResults: [],
        uploadErrors: [],
         uploading: false,
         csvValid: false,
         previewHeaders: [],
         previewRows: [],
            // no preview modal; download directly
    }),

    mounted(){
        this.getActivities()
    },

    methods:{
        async getActivities (val) {
            const requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
            };
            try{
              this.loading = true
              const res = await fetch(process.env.VUE_APP_URL+'/stockadjustments', requestOptions)
              const data = await res.json()
              if(data.status == true){
                    this.activities = data.stocks
                    this.activitiesDatas = this.activities
                    this.processedData = this.preprocessData(data.stocks);
                    if(!val)
                      this.initializeDataTable();
                }else{
                Swal.fire({
                    icon: 'error',
                    title: 'Stock Adjustment List not found',
                    text: data.message
              })
                }
            } catch(err) {
              //console.error(err)
            } finally {
              this.loading = false
            }
        },

          async downloadTemplate() {
            try {
              // If modal preview is present use it to generate CSV client-side (avoids another fetch)
              if (this.showTemplateModal && this.modalPreviewHeaders && this.modalPreviewRows) {
                const headers = this.modalPreviewHeaders;
                const rows = this.modalPreviewRows;
                const lines = [headers.join(',')];
                for (const r of rows) {
                  const cols = headers.map(h => {
                    const v = r[h] ?? '';
                    // escape any quotes and wrap in quotes if contains comma
                    const s = String(v).replace(/"/g, '""');
                    return s.includes(',') ? `"${s}"` : s;
                  });
                  lines.push(cols.join(','));
                }
                const csv = lines.join('\n');
                const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = this.modalFileName || 'stock_adjustment_template.csv';
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
                return;
              }

              // fallback: fetch from server
              const res = await fetch(process.env.VUE_APP_URL + '/stockadjustments/template', {
                method: 'GET',
                headers: { 'Authorization': 'Bearer ' + this.token },
              });
              if (!res.ok) {
                const body = await res.json().catch(() => null);
                Swal.fire({ icon: 'error', title: 'Download failed', text: body?.message || res.statusText });
                return;
              }
              const blob = await res.blob();
              const disposition = res.headers.get('content-disposition');
              let filename = 'stockadjustment_template.csv';
              if (disposition) {
                const m = /filename\*?=([^;]+)/.exec(disposition);
                if (m) filename = m[1].replace(/UTF-8''/, '').replace(/"/g, '').trim();
              }
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = filename;
              document.body.appendChild(a);
              a.click();
              a.remove();
              window.URL.revokeObjectURL(url);
            } catch (err) {
              Swal.fire({ icon: 'error', title: 'Download error', text: err.message || String(err) });
            }
          },

          // preview functionality removed; downloads happen directly via downloadTemplate

          onFileChange(e) {
            const f = e.target.files && e.target.files[0];
            this.uploadFile = f || null;
            this.previewRows = [];
            this.previewHeaders = [];
            this.csvValid = false;
            if (!f) return;
            const ext = (f.name || '').split('.').pop().toLowerCase();
            if (ext === 'xlsx' || ext === 'xls') {
              // allow XLSX/XLS uploads; server will validate contents
              this.csvValid = true;
              this.previewHeaders = ['Product Name', 'Old Quantity', 'New Quantity'];
              this.previewRows = [];
              return;
            }
            const reader = new FileReader();
            reader.onload = (ev) => {
              const text = ev.target.result;
              if (!text) return;
              const lines = String(text).split(/\r?\n/).filter(l => l.trim().length > 0);
              if (lines.length === 0) return;
              // naive CSV split for header (handles quoted headers simply)
              const rawHeader = lines[0].split(',').map(h => h.replace(/^\s*"|"\s*$/g, '').trim());
              this.previewHeaders = rawHeader;
              const required = ['product name', 'new quantity'];
              const headerLower = rawHeader.map(h => h.toString().toLowerCase());
              this.csvValid = required.every(r => headerLower.some(h => h.includes(r)));
              // build preview rows (first 5)
              const maxPreview = Math.min(5, lines.length - 1);
              for (let i = 0; i < maxPreview; i++) {
                const cols = lines[i+1].split(',').map(c => c.replace(/^\s*"|"\s*$/g, '').trim());
                const obj = {};
                rawHeader.forEach((h, idx) => { obj[h] = cols[idx] || ''; });
                this.previewRows.push(obj);
              }
            };
            reader.readAsText(f);
          },

          async uploadCsv() {
            if (!this.uploadFile) return;
            if (!this.csvValid) { Swal.fire({ icon: 'error', title: 'Invalid CSV', text: 'CSV headers are invalid. Please use the template.' }); return; }
            this.uploading = true;
            this.uploadResults = [];
            this.uploadErrors = [];
            try {
              const form = new FormData();
              form.append('file', this.uploadFile);
              const res = await fetch(process.env.VUE_APP_URL + '/stockadjustments/upload', {
                method: 'POST',
                headers: { 'Authorization': 'Bearer ' + this.token },
                body: form,
              });
              const data = await res.json();
              if (data.status === true) {
                this.uploadResults = data.results || [];
                this.uploadErrors = data.errors || [];
                // refresh table
                this.getActivities(true);
                const successCount = this.uploadResults.length;
                const errorCount = this.uploadErrors.length;
                Swal.fire({ icon: 'success', title: 'Upload processed', text: `${successCount} rows succeeded, ${errorCount} rows failed.` });
              } else {
                // Show detailed parseError or validation errors when provided by backend
                if (data.parseError) {
                  const msg = `Parse error: ${data.parseError.message}${data.parseError.line ? ' (line ' + data.parseError.line + ')' : ''}`;
                  this.uploadErrors = [{ sheet: 'CSV', row: data.parseError.line || '-', message: data.parseError.message }];
                  Swal.fire({ icon: 'error', title: 'CSV Parse Error', text: `0 rows succeeded, 1 row failed. ${msg}` });
                } else if (Array.isArray(data.errors) && data.errors.length > 0) {
                  // If backend returned processed results for valid rows, show them too
                  this.uploadResults = data.results || [];
                  // Map backend errors to uploadErrors table
                  this.uploadErrors = data.errors.map(e => ({ sheet: e.sheet || 'CSV', row: e.row || '-', product: e.product || '-', message: e.message }));
                  const successCount = (data.results && Array.isArray(data.results)) ? data.results.length : 0;
                  const errorCount = data.errors.length;
                  // Build a short message for the toast (first 8 errors)
                  const lines = this.uploadErrors.slice(0, 8).map(e => `${e.sheet} row ${e.row}: ${e.product && e.product !== '-' ? e.product + ' - ' : ''}${e.message}`);
                  const more = data.errors.length > 8 ? `\n...and ${data.errors.length - 8} more` : '';

                  // If backend returned annotatedCsv, create a downloadable blob and include a link in the toast
                  if (data.annotatedCsv) {
                    const blob = new Blob([data.annotatedCsv], { type: 'text/csv;charset=utf-8;' });
                    const url = window.URL.createObjectURL(blob);
                    const headerHtml = `<div style="font-weight:600; margin-bottom:8px;">${successCount} rows succeeded, ${errorCount} rows failed</div>`;
                    const html = headerHtml + `<div style="white-space:pre-wrap; text-align:left;">${lines.join('<br/>')}${more.replace(/\n/g,'<br/>')}</div><div style="margin-top:10px"><a href="${url}" download="annotated_stock_adjustments.csv" class="btn btn-sm btn-primary">Download annotated CSV</a></div>`;
                    Swal.fire({ icon: 'error', title: 'Validation failed', html, showCloseButton: true, didClose: () => { window.URL.revokeObjectURL(url); } });
                  } else {
                    Swal.fire({ icon: 'error', title: 'Validation failed', text: `${successCount} rows succeeded, ${errorCount} rows failed.\n${lines.join('\n')}${more}` });
                  }
                } else {
                  Swal.fire({ icon: 'error', title: 'Upload failed', text: data.message || 'Upload returned an error' });
                }
              }
            } catch (err) {
              console.error(err);
              Swal.fire({ icon: 'error', title: 'Upload error', text: err.message || String(err) });
            } finally {
              this.uploading = false;
            }
          },


        reinitializeTable(){
          this.dataTable.clear()
          this.dataTable.rows.add(this.preprocessData(this.activitiesDatas))
          this.dataTable.draw()
        },

        async clear(){
          this.dateFrom = ""
          this.dateTo = ""
          this.reinitializeTable()

        },

        preprocessData(rawData) {
        return rawData.map(item => {
          let status =  "";
          
          if(item.status == 'pending'){
            status = '<button class="btn btn-warning btn-sm" style="border-radius: 15px" >Pending</button>'
          }
          if(item.status == 'done'){
            status = '<button class="btn btn-success btn-sm" style="border-radius: 15px" >Completed</button>'
          }

          return {
            indexNo:"1",
            createdAt: this.formatDate(item.createdAt, "true"),
            type: item.type,
            productName: this.truncateString(item.Product.name),
            warehouse: item.Inventory.Warehouse.name,
            oldQuantity: this.formatQty(item.oldQuantity),
            quantity: this.formatQty(item.quantity),
            newQuantity: this.formatQty(item.newQuantity),
            comment: this.truncateString(item.comment),
            userName: item.Approval?.requestedBy?.name,
            approverName: item.Approval?.approvedBy?.name,
            approveDate: this.formatDate(item.Approval?.updatedAt, "true"),
            status
          };
        });
      },
      initializeDataTable() {
        try{
          this.dataTable = $(this.$el).find('#adjustmentsTable').DataTable({
            language: {
              paginate: {
                previous: '<i class="fa fa-chevron-left"></i>', // Custom icon for previous button
                next: '<i class="fa fa-chevron-right"></i>', // Custom icon for next button
              },
            },
            dom: 'Bfrtip',
            buttons: [  
            'colvis',
            'pageLength', 
            {
              extend: 'csv',
              text: 'Export CSV',
              className: 'btn btn-primary',
              exportOptions: {
                columns: ':visible', 
              },
            },
            {
                extend: 'pdfHtml5',
                text: 'Export PDF',
                className: 'btn btn-primary',
                orientation: 'portrait', 
                exportOptions: {
                  columns: ':visible', 
                },
                customize: this.customizePDF
              },
          ],
            data: this.processedData,
            columns: [
              { data: null },
              { data: 'createdAt' },
              { data: 'type' },
              { data: 'productName' }, 
              { data: 'warehouse' }, 
              { data: 'oldQuantity' }, 
              { data: 'quantity' }, 
              { data: 'newQuantity' }, 
              { data: 'comment', defaultContent: '-' },
              { data: 'userName', defaultContent: '-' }, 
              { data: 'approverName', defaultContent: '-' },
              { data: 'approveDate', defaultContent: '-' },
              { data: 'status', defaultContent: '-' }
            ],
            columnDefs: [
              {
                targets: 0,
                searchable: false,
                orderable: false,
                render: (data, type, row, meta) => {
                  return meta.row + 1;
                },
              },
            ],
          });
        } catch(error){
          //console.log({error})
        }
      },
      
      convertDate(dateString) {
        const parts = dateString.split("/")
        const newDate = `${parts[1]}/${parts[0]}/${parts[2]}`;
        return newDate;
      },


      filterTable() {
        if (!this.dateFrom || !this.dateTo) {
          console.error("Invalid date inputs");
          return;
        }

        const fromDate = new Date(this.dateFrom);
        const toDate = new Date(this.dateTo);

        if (isNaN(fromDate) || isNaN(toDate)) {
          console.error("Invalid date values");
          return;
        }

        $.fn.dataTable.ext.search.push((settings, data, dataIndex) => {
          const dateStr = data[1]; 
          const parsedDate = this.convertDate(dateStr);
          const date = new Date(parsedDate);
          //console.log(settings)
          console.log(dataIndex)
          if (!isNaN(date)) {
            //console.log("From Date", fromDate)
            //console.log("Date", date)
            //console.log("To Date", toDate)

            return date >= fromDate && date <= toDate;
          }
          return false;
        });
        this.dataTable.draw();
        $.fn.dataTable.ext.search.pop();
      },

      customizePDF(doc) {
      //const logoBase64 = this.convertToBase64(logo)
      //console.log(logoBase64)
      const profile = JSON.parse(localStorage.getItem('profile'))
      doc.pageMargins = [40, 40, 40, 40]; // Set margins for the entire page
      doc.defaultStyle.columnGap = 0
      doc.content[1].fillColor = '#f2f2f2'

      doc.header = () => {
        return {
          columns: [
            {
              width: '*',
              columns: [
                /* {
                     image: logoBase64,
                     width: 150, // Adjust the width as needed
                 },*/
                {
                  text: profile?.businessName,
                  alignment: 'left',
                  margin: [40, 15, 0, 40], // Adjust margins as needed
                  color: '#FFA500', // Orange color
                  bold: true,
                  fontSize: 14,

                }
              ]
            },
            {
              width: '*',
              stack: [
                {
                  text: 'Stock Adjustments',
                  alignment: 'right',
                  margin: [0, 15, 50, 0],
                  fontSize: 12,
                  color: '#000000'
                },
                {  
                  alignment: 'right',
                  margin: [300, 0, 0, 0],
                  width: '*',
                  columns: [
                    {
                      width: 'auto',
                      text: 'Date:',
                      alignment: 'right',
                      margin: [0, 0, 10, 0],
                      bold: true,
                    },
                    {
                      width: 'auto',
                      text: `${this.formatDate(new Date(), "true")}`,
                      alignment: 'right',
                      margin: [0, 0, 50, 0],
                      fontSize: 9
                    }
                  ]
                }
              ]
            }
          ],
          fillColor: '#000000'
        };
      },

      doc.footer = (currentPage, pageCount) => docFooter(currentPage, pageCount)

      doc.styles.title = {
        color: '#000000',
        fontSize: 13,
        margin: [80, 0, 0, 40],
      };
    }
    }
  }
  </script>

<style scoped>
.inventory {

}

.file-input-wrapper {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.file-input-wrapper .file-input {
  display: none;
}
.file-input-wrapper .file-label {
  padding: 4px 10px;
  font-size: 11px;
  color: #495057;
  background: transparent;
  border: 1px solid #ced4da;
  border-radius: 4px;
}
.file-input-wrapper .file-label:hover {
  background: #f8f9fa;
}
.file-input-wrapper .file-name {
  font-size: 11px;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Custom DataTable button styling */
:deep(.dt-buttons) {
  margin-bottom: 1rem;
}

:deep(.dt-button) {
  background-color: #f8f9fa !important;
  color: #495057 !important;
  border: 1px solid #dee2e6 !important;
  border-radius: 0 !important;
  margin: 0 !important;
  padding: 6px 11px !important;
  font-size: 11px !important;
  font-weight: 500 !important;
}

:deep(.dt-button:hover) {
  background-color: #e9ecef !important;
  color: #495057 !important;
}

</style>

/* No preview modal styles; download template directly */
